import { Component, Input, OnInit } from '@angular/core';
import { QrGeneratorNavigatorCategories } from 'shared-library';
import { CoreService } from '@app/modules/core/services/core.service';
import { CoreProductUseCase } from '@app/store/models/core-product-use-cases.interface';

@Component({
  selector: 'app-core-product-use-cases-wrapper',
  templateUrl: './core-product-use-cases-wrapper.component.html',
  styleUrls: ['./core-product-use-cases-wrapper.component.scss']
})
export class CoreProductUseCasesWrapperComponent implements OnInit {

  @Input() view_type: "view1" | "view2" = "view1"
  @Input() qr_category: QrGeneratorNavigatorCategories = QrGeneratorNavigatorCategories.MEMORIES

  all_use_cases: CoreProductUseCase[] = []

  constructor(
    private coreService: CoreService
  ) { }

  ngOnInit(): void {
    this.all_use_cases = this.coreService.allProductUseCases().filter(({ perfect_for }) => this.qr_category === perfect_for)
  }

  isActivePage(use_case: CoreProductUseCase): boolean {
    return window.location.href.endsWith(use_case.type)
  }

}

